<template>
  <customize-page
    label-position="left"
    ref="page"
    inline
    :loading="loading"
    :data="downloadList"
    :columns="columns"
    :pagination="pagination"
    :formConfig="getFormConfig()"
    :filterObj="filterObj"
    :hideOperate="true"
    @size-change="handleSizeChange"
    @on-selection-change="selectionChange"
    @current-change="handleCurrentChange"
  >
    <div slot="footer">
      <!-- <el-button style="margin-right:10px;" type="primary" @click="search">搜索</el-button> -->
      <!-- <el-button style="margin-right:10px;" @click="reset">重置</el-button> -->
      <span>导入列表</span>
      <el-button style="float: right" type="text" @click="fetch()"
        >刷新列表
      </el-button>
    </div>
  </customize-page>
</template>

<script>
import { formatDate } from "@/utils/common";
import download from "@/api/download";
import Page from "@/mixin/Page";
import CustomizePage from "@/components/customize-page";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  data() {
    return {
      downloadList: [],
      loading: false,
      columns: [
        {
          title: "报表名称",
          key: "fileName",
          align: "center",
        },
        {
          title: "开始时间",
          key: "startTime",
          align: "center",
          render(h, params) {
            const startTime = params.row.startTime;
            return <div>{formatDate(startTime)}</div>;
          },
        },
        {
          title: "完成时间",
          key: "endTime",
          align: "center",
          render(h, params) {
            const endTime = params.row.endTime;
            return <div>{formatDate(endTime)}</div>;
          },
        },
        {
          title: "状态",
          key: "downloadState",
          align: "center",
          render(h, params) {
            const stateMap = {
              SUBMIT: "已提交",
              WAITING: "等待中",
              CANCEL: "已取消",
              REJECTED: "已拒绝",
              RUNNING: "运行中",
              EXCEPTION: "异常",
              COMPLETED: "已完成",
            };
            const tagTypeMap = {
              SUBMIT: "warning",
              WAITING: "warning",
              CANCEL: "danger",
              REJECTED: "danger",
              RUNNING: "",
              EXCEPTION: "danger",
              COMPLETED: "success",
            };
            const state = params.row.downloadState;
            return <el-tag type={tagTypeMap[state]}>{stateMap[state]}</el-tag>;
          },
        },
        // {
        // 	title: "下载次数",
        // 	width: 150,
        // 	key: "remark",
        // 	align: "center",
        // 	tooltip: true
        // },
        {
          title: "操作",
          width: 150,
          key: "downloadState",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return (
              <div>
                <el-button
                  v-show={row.downloadState == "COMPLETED"}
                  type="text"
                >
                  <a href={row.filePath}>下载</a>
                </el-button>
                <el-button
                  v-show={row.downloadState == "COMPLETED"}
                  type="text"
                >
                  <a
                    onClick={() => {
                      this.loading = true;
                      download
                        .submitImportTask({
                          taskId: row.taskId,
                        })
                        .then((res) => {
                          this.loading = false;
                          this.fetch();
                          if (res.value) {
                            this.$message.success("同步成功");
                          }
                        });
                    }}
                  >
                    同步
                  </a>
                </el-button>
              </div>
            );
          },
        },
      ],
      tableHeight: 300,
    };
  },
  mounted() {
    this.fetch();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.__resizeHandler);
  },
  activated() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateTimeStart = new Date(
          filterParams.applyTime[0] + " 00:00:00"
        ).getTime();
        filterParams.gmtCreateTimeEnd = new Date(
          filterParams.applyTime[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateTimeStart;
        delete filterParams.gmtCreateTimeEnd;
      }
      let searchCondition = {
        request: {
          ...filterParams,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      download.queryImportHistory(searchCondition).then((res) => {
        this.loading = false;
        this.downloadList = res.result;
        const pageInfo = res.pageInfo || { totalCount: 0 };
        this.pagination = { ...this.pagination, ...pageInfo };
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
      let flag = false;
      rows.map((item) => {
        if (
          item.checklistStatus !== "CUSTOMS_EXCEPTION" &&
          item.checklistStatus !== "INPUT_COMPLETED"
        ) {
          flag = true;
        }
      });
      this.pushDisabled = flag;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            // {
            //   label: "报表名称",
            //   model: "popName",
            //   type: type.INPUT,
            //   placeholder: "请输入报表名称"
            // },
            // {
            //   label: "完成时间",
            //   model: "applyTime",
            //   type: type.DATE_RANGE,
            //   className: "flex-form-item"
            // },
          ],
        },
      ];
    },
  },
};
</script>
